import axios from "axios";
//import config from '../env.js';
import { Cookies } from 'quasar'

//var username = localStorage.getItem("username")
// console.log(json_arr);

class eServiceDataService {
    baseUrl() {
        const config = JSON.parse(localStorage.getItem('config'));
        //console.log(config);
        return process.env.VUE_APP_ENV === 'prod' ? config.prd_ApiUrl : config.api_Url;
    }
    getUserName(){
        var username = localStorage.getItem("username")
        return username;
    }

    async getJson() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getJson", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            });
    }

    async getPDFList() {
        var username = this.getUserName();
        var req_user = '';

        if (process.env.VUE_APP_ENV === 'prod') {
            switch (username) {
                case 'vtc':
                    req_user = 'vtc';
                    break;
                case 'hkjc':
                    req_user = 'jc';
                    break;
                case 'cuhk':
                    req_user = 'cuhk';
                    break;
                default:
                    req_user = '*';
            }
        } else if (["uat", "test"].includes(process.env.VUE_APP_ENV)) {
            switch (username) {
                case 'vtcstaff':
                    req_user = 'vtc';
                    break;
                case 'jcstaff':
                    req_user = 'jc';
                    break;
                case 'cuhkstaff':
                    req_user = 'cuhk';
                    break;
                default:
                    req_user = '*';
            }
        }

        return axios.post(this.baseUrl() + "/p/eservice/getallpdflist", { env: (process.env.VUE_APP_ENV === 'test' ? 'uat' : process.env.VUE_APP_ENV), user: req_user });
    }

    async getSpecialOption() {
        const accessToken = Cookies.get('accessToken')
        return axios.post(this.baseUrl() + "/eservice/getspecialoption", {  },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            });
    }

    async getProviderType() {
        const accessToken = Cookies.get('accessToken')
        return axios.post(this.baseUrl() + "/eservice/getprovidertype", {  },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            });
    }

    getDisplayName() {
        const accessToken = Cookies.get('accessToken')
        return axios.post(this.baseUrl() + "/eservice/getdisplayname", {  },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getGroupID() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getgroupid", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getNewsList() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getnewsfile", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getUserCscode() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getcscode", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getNetworkId() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getnetworkid", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getFilename() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getfilename", {  },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }

    async getNonEocssList() {
        const accessToken = Cookies.get('accessToken')
        return await axios.post(this.baseUrl() + "/eservice/getnoneocssfile", { },
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'accessToken' : accessToken
                }
            })
    }
}

export default new eServiceDataService();
